// extracted by mini-css-extract-plugin
export default {"PaymentWrapper":"styles_PaymentWrapper__-LB9G","PaymentHead":"styles_PaymentHead__zyvKD","PaymentContainer":"styles_PaymentContainer__meIIV"};